









































import Vue from "vue";
import anime from "animejs";

import { IDateFilterValue } from "../store/state";

interface IDateValueProps extends IDateFilterValue {
  displayName: string;
  open: boolean;
}

interface IDateValueData {
}

interface IDateValueMethods {
  toggleOpen(): void;
  beforeOpen(el: HTMLElement): void;
  animateOpen(el: HTMLElement, done: any): void;
  animateClose(el: HTMLElement, done: any): void;
}

export default Vue.extend<
  IDateValueData,
  IDateValueMethods,
  {},
  IDateValueProps
>({
  props: {
    year: Number,
    months: Array,
    displayName: String,
    open: Boolean
  },
  data() {
    return {
    };
  },
  methods: {
    beforeOpen(el) {},
    animateOpen(el, done) {
      anime({
        targets: el,
        height: [0, el.offsetHeight],
        duration: 250,
        elasticity: 0,
        easing: "linear",
        complete: () => {
          const firstInput = (this.$refs.filter as Element).querySelector(
            "label"
          );
          el.style.height = "";
          if (firstInput) {
            (firstInput as HTMLElement).focus();
          }
          done();
        }
      });
    },
    animateClose(el, done) {
      anime({
        targets: el,
        height: [el.offsetHeight, 0],
        duration: 250,
        elasticity: 0,
        easing: "linear",
        complete: () => {
          el.style.height = "";
          done();
        }
      });
    },
    toggleOpen() {
      this.$emit('open', this.year);
    }
  }
});
